import React from 'react';

const CloseGray = () => {
  return(
    <svg width="22px" height="22px" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" fill="none" fill-rule="evenodd">
        <g transform="translate(-13, -13)">
          <rect x="0" y="0" width="48" height="48"></rect>
          <path d="M25.4145,23.9995 L34.7065,14.7065 C35.0975,14.3165 35.0975,13.6835 34.7065,13.2925 C34.3165,12.9025 33.6835,12.9025 33.2925,13.2925 L23.9995,22.5855 L14.7065,13.2925 C14.3165,12.9025 13.6835,12.9025 13.2925,13.2925 C12.9025,13.6835 12.9025,14.3165 13.2925,14.7065 L22.5855,23.9995 L13.2925,33.2925 C12.9025,33.6835 12.9025,34.3165 13.2925,34.7065 C13.4885,34.9025 13.7445,34.9995 13.9995,34.9995 C14.2555,34.9995 14.5115,34.9025 14.7065,34.7065 L23.9995,25.4135 L33.2925,34.7065 C33.4885,34.9025 33.7445,34.9995 33.9995,34.9995 C34.2555,34.9995 34.5115,34.9025 34.7065,34.7065 C35.0975,34.3165 35.0975,33.6835 34.7065,33.2925 L25.4145,23.9995" fill="#363636"></path>
        </g>
      </g>
    </svg>
  )
};

export default CloseGray;



/** WEBPACK FOOTER **
 ** ./shared-components/Svg/CloseGray.js
 **/